export var getFocusableElements = function (ref) {
    if (!ref.current) {
        return [];
    }
    return Array.from(ref.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
};
